/**
 * @module 招贤纳士-路由配置
 * @author Teacher Tang
 * @date 2019-09-23 11:04:10
 */
// 布局
import { LayoutBase, LayoutA } from '../layout/index';
// 页面（按需包装布局）CandidateList
import {
  Home,
  Login,
  ResumeList,
  ResumeSearch,
  ResumeDetail,
  WorkExper,
  ProjectExper,
  CandidateList,
  CandidateDetail,
  CandidateSearch,
  PostPosition,
  JobList,
  PositionLegal,
  HuntJob,
  HuntJobSearch,
  HuntJobList,
  HuntJobOffer,
  Business,
  BusinessSearch,
  ZhaopinHome
} from '../pages';

// 路由设置（被嵌套组件，需支持children）
export default {
  path: '/',
  component: LayoutBase,
  routes: [
    {
      path: '/',
      isExact: true,
      component: Home
    },
    {
      path: '/login',
      component: LayoutA,
      routes: [
        {
          path: '/login',
          isExact: true,
          component: Login
        }
      ]
    },
    {
      path: '/zhaopin/resumes/list',
      isExact: true,
      component: ResumeList
    },
    {
      path: '/zhaopin/resumes/search',
      isExact: true,
      component: ResumeSearch
    },
    {
      path: '/zhaopin/resumes/detail/:uuid',
      isExact: true,
      component: ResumeDetail
    },
    {
      path: '/zhaopin/resumes/workexper',
      isExact: true,
      component: WorkExper
    },
    {
      path: '/zhaopin/resumes/projectexper',
      isExact: true,
      component: ProjectExper
    },
    // 候选人管理
    {
      path: '/zhaopin/candidate',
      isExact: true,
      component: CandidateList
    },
    {
      path: '/zhaopin/candidate/detail/:uuid',
      isExact: true,
      component: CandidateDetail
    },
    {
      path: '/zhaopin/candidate/search',
      isExact: true,
      component: CandidateSearch
    },
    {
      // 职位管理
      path: '/zhaopin/job/list',
      isExact: true,
      component: JobList
    },
    {
      // 职位发布规则
      path: '/zhaopin/position/legal',
      isExact: true,
      component: PositionLegal
    },
    {
      // 发布职位
      path: '/zhaopin/position/:uuid?',
      isExact: true,
      component: PostPosition
    },
    {
      // 猎职位
      path: '/zhaopin/huntjob/:role',
      isExact: true,
      component: HuntJob
    },
    {
      // 猎职位
      path: '/zhaopin/huntjobSearch/:role',
      isExact: true,
      component: HuntJobSearch
    },
    {
      // 猎职位
      path: '/zhaopin/huntjoblist/:role/:status',
      isExact: true,
      component: HuntJobList
    },
    {
      // 猎职位
      path: '/zhaopin/huntjobOffer/:id',
      isExact: true,
      component: HuntJobOffer
    },
    {
      // 企业商机
      path: '/zhaopin/business',
      isExact: true,
      component: Business
    },
    {
      // 企业商机
      path: '/zhaopin/business/search',
      isExact: true,
      component: BusinessSearch
    },
    {
      // 企业商机
      path: '/zhaopin/home',
      isExact: true,
      component: ZhaopinHome
    }
  ]
};
